import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";

export default function OrderDialog({ open, onClose }) {
  const [productHandle, setProductHandle] = useState("");
  const [qty, setQty] = useState(1);
  const [notes, setNotes] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const send = () => {
    const body = [
      "Hi Team,",
      "",
      `I'd like to order/inquire about:`,
      `- Product handle: ${productHandle || "N/A"}`,
      `- Quantity: ${qty}`,
      notes ? `- Notes: ${notes}` : "",
      "",
      "Please confirm availability, price and shipping to the USA.",
      "Thanks!",
    ].join("%0A");
    window.location.href = `mailto:orders@catalog.com?subject=Order%20Inquiry&body=${encodeURIComponent(body)}`;
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem' } }}>
        How to order
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            mb: 2,
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          Enter product handle (copy from list) and quantity, then click Send Inquiry.
        </Typography>
        <Stack spacing={2}>
          <TextField 
            label="Product handle (copy from list)" 
            size="small" 
            value={productHandle} 
            onChange={(e) => setProductHandle(e.target.value)} 
            fullWidth
          />
          <TextField 
            label="Quantity" 
            size="small" 
            type="number" 
            value={qty} 
            onChange={(e) => setQty(Math.max(1, parseInt(e.target.value || "1", 10)))} 
            fullWidth
          />
          <TextField 
            label="Notes (optional)" 
            size="small" 
            multiline 
            rows={3} 
            value={notes} 
            onChange={(e) => setNotes(e.target.value)} 
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} sx={{ flex: isMobile ? 1 : 'none' }}>
          Cancel
        </Button>
        <Button 
          variant="contained" 
          onClick={send} 
          startIcon={<MailIcon />}
          sx={{ flex: isMobile ? 1 : 'none' }}
        >
          Send Inquiry
        </Button>
      </DialogActions>
    </Dialog>
  );
}